const others = {
  param: 'Parameters',
  message: 'Whenever we have any news, we will keep you informed here!',
  matchTrue: 'Select one of the options on the side to start',
  matchFalse: 'Select one of the options below to get started',
  infoLabel: 'Latest notices',
  infoMsg: 'no warnings at the moment'
}

export default others;
